import { Component, input } from '@angular/core';
@Component({
  selector: 'app-status-badge',
  templateUrl: './status-badge.component.html',
})
export class StatusBadge {
  status = input.required<string>();
  displayLabel = input<string>();
  tone = input<'success' | 'danger' | 'warning' | 'info' | 'purple' | 'neutral'>();

  badgeClass(): string {
    const baseClass = 'inline-flex items-center rounded-full px-2 py-1 text-xs font-semibold ring-1 text-[10px] whitespace-nowrap ';
    const toneClasses = {
      success: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
      danger: 'bg-red-50 text-red-700 ring-red-200',
      warning: 'bg-amber-50 text-amber-700 ring-amber-200',
      info: 'bg-sky-50 text-sky-700 ring-sky-200',
      purple: 'bg-violet-50 text-violet-700 ring-violet-200',
      neutral: 'bg-slate-100 text-slate-700 ring-slate-200',
    } as const;

    const s = this.status();
    const mappedTone =
      s === 'JOIN_TOUR'
        ? 'info'
        : s === 'GROUP_TOUR'
          ? 'purple'
          : s === 'CONFIRMED'
            ? 'info'
            : s === 'COMPLETED'
              ? 'neutral'
            : s === 'REFUND'
              ? 'neutral'
              : s === 'REFUND_PENDING'
                ? 'warning'
              : ['PAID', 'VERIFIED', 'APPROVED', 'ACTIVE'].includes(s)
            ? 'success'
            : ['REJECTED', 'CANCELLED', 'DELETED', 'OVERPAID'].includes(s)
              ? 'danger'
              : [
                    'PARTIAL',
                    'WAITING_VERIFY',
                    'WAITING_APPROVAL',
                    'SUBMITTED',
                    'SUPERVISOR_REVIEW',
                    'WAITING_PAYMENT',
                    'WAITING_CLEARING',
                    'SUSPENDED',
                    'ACCOUNTING_REVIEW',
                    'ACCOUNTING_REVIEW_RECEIPT',
                    'PENDING_CONFIRMATION',
                  ].includes(s)
                ? 'warning'
                : 'neutral';

    return `${baseClass} ${toneClasses[this.tone() ?? mappedTone]}`;
  }

  label(): string {
    const labels: Record<string, string> = {
      ACTIVE: 'ใช้งาน',
      SUSPENDED: 'ระงับการใช้งาน',
      DELETED: 'ถูกลบ',
      DRAFT: 'ฉบับร่าง',
      COMPLETED: 'ปิดเคส',
      REFUND_PENDING: 'อยู่ระหว่างคืนเงิน',
      REFUND: 'คืนเงินเสร็จสิ้น',
      UNPAID: 'ยังไม่ชำระ',
      PARTIAL: 'ชำระบางส่วน',
      PAID: 'จ่ายครบแล้ว',
      OVERPAID: 'ชำระเกิน',
      WAITING_VERIFY: 'รอตรวจสอบ',
      WAITING_APPROVAL: 'รออนุมัติ',
      VERIFIED: 'ตรวจสอบแล้ว',
      REJECTED: 'ไม่ผ่าน',
      CANCELLED: 'ยกเลิก',
      SUBMITTED: 'รอบัญชีตรวจ',
      SUPERVISOR_REVIEW: 'รอหัวหน้าอนุมัติ',
      ACCOUNTING_REVIEW: 'รอบัญชีอนุมัติ',
      ACCOUNTING_REVIEW_RECEIPT: 'รอบัญชีตรวจใบเสร็จ',
      APPROVED: 'อนุมัติแล้ว',
      WAITING_PAYMENT: 'รอบัญชีจ่ายเงิน',
      WAITING_CLEARING: 'รอใบเสร็จ',
      PENDING_CONFIRMATION: 'รอยืนยันการจอง',
      CONFIRMED: 'ยืนยันการจองแล้ว',
      JOIN_TOUR: 'จอยทัวร์',
      GROUP_TOUR: 'เหมากรุ๊ป',
    };
    return this.displayLabel() ?? labels[this.status()] ?? this.status();
  }
}
